import { useEffect, useState } from "react";

import { onBrowser } from "./onBrowser";

export function useWindowSize() {
  function getWindowSize() {
    // istanbul ignore next - simple node short-circuit
    if (!onBrowser()) {
      return { width: undefined, height: undefined };
    }
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  }

  const [windowSize, setWindowSize] = useState(getWindowSize);

  useEffect(() => {
    // istanbul ignore next - simple node short-circuit
    if (!onBrowser()) {
      return;
    }

    let timer: any;
    function handleResize() {
      clearTimeout(timer);
      timer = setTimeout(() => setWindowSize(getWindowSize()), 100);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowSize;
}
